import { useNavigate } from 'react-router-dom';
import './StudentGrid.css';

const Card = ({ title, description }) => {
  const navigate = useNavigate();

  const handleApply = () => {
    navigate('/register');
  };

  const handleLogin = () => {
    navigate('/login');
  };

  return (
    <div className="cardS">
      <h2>{title}</h2>
      <div className="card-content">
        <p>{description}</p>
        <div className="card-buttons">
          <button className="card-button-1 " onClick={handleApply}>Apply</button>
          <button className="card-button-outline" onClick={handleLogin}>Login</button>
        </div>
      </div>
    </div>
  );
};

const StudentGrid = () => {
  const cards = [
    { title: 'Umhlanga Junction', description: 'Fully Booked' },
    { title: 'Ekhaya Junction', description: '1 Bed Left.' },
    { title: 'Mill Junction', description: 'Available.' },
  ];

  return (
    <div className="page-background"> {/* Added background wrapper here */}
      <div className="card-grid">
        <h1>Hello Student Accommodation</h1>
        <br />
        {cards.map((card, index) => (
          <Card key={index} title={card.title} description={card.description} />
        ))}
      </div>
    </div>
  );
};

export default StudentGrid;
